import { DividerComponent } from './divider.component';

export default angular
  .module('sfMobile.components.divider', [])
  .component('sfDivider', DividerComponent).name;
